import $ from 'jquery';
import stickybits from 'stickybits';
import FloatLabels from 'float-labels.js';


/* Global variables
********************************************/

const stickyHeight = 60;
const mobileHeight = 50;


/* IE classes
********************************************/

let isIE = false;
if (/MSIE 10/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-10');
}
if (/rv:11.0/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-11');
}



/* Sticky header
********************************************/

stickybits( '.js-sticky-block', {
	useStickyClasses: true,
	//useFixed: true,
	//stickyBitStickyOffset: - pageHeaderHeight - 20,
	//customStickyChangeNumber: 10
} );



/* Smooth scroll
********************************************/

$('a[href*="#"]:not([href="#"])').click(function () {
	var $this = $(this);
	if ($this.parents('.js-no-smooth-scroll').length == 0 && $this.parents('.js-tabs-nav').length == 0) {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);

			if ( target.length && target.hasClass( 'js-gallery-modal' ) ) {
				// this is a gallery modal button/link, don't smooth scroll this
				return;
			}

			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - stickyHeight + 1
				}, 500);
				return false;
			}
		}
	}
});



/* Tables
********************************************/

if ($('table').length) {
	$('table').wrap('<div class="c-table-wrapper"></div>');
}


/* Floating labels
********************************************/

new FloatLabels( '.js-float-labels', {});



/* iOS vieport fix
********************************************/

window.onresize = function() {
	var windowHeight = window.innerHeight;
	document.body.height = windowHeight;
	$(".c-offcanvas").css("height", windowHeight);
}
window.onresize(); // called to initially set the height.
